var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModelMediaStreamEndedMessage, ModelMediaVideoInvalidMessage, ModelMediaVideoResizedMessage, RequestFullscreenMessage, ModelMediaStreamStartedMessage, RequestStartScreenStreamMessage, RequestStopScreenStreamMessage, RequestStartPlayer3DViewSharingMessage as RequestStartPlayer3dViewSharingMessage, RequestStopPlayer3DViewSharingMessage as RequestStopPlayer3dViewSharingMessage, CopyMediaFileToClipboardMessage, DownloadMediaFileMessage, ShareMediaFileMessage, StopShareMediaFileMessage } from "../../../messages/media";
import { AskOkMessage, RemoveSubModelMessage, RoomChangedMessage } from "flavr-common";
import { busService } from "../../bus";
import { resolveUid } from "../model/Utils";
import { networkEntitiesService } from "../../network/NetworkEntitiesService";
import { coreUserService } from "../../users";
import { IsXrPresentingAnswerMessage, IsXrPresentingRequestMessage } from "../../../messages/rendering/MeshMessages";
const connection = busService.connection("ScriptMediaManager");
const streamStartedSubscriptions = new Map();
const streamEndedSubscriptions = new Map();
const remoteStreamEndedSubscriptions = new Map();
const resizedSubscriptions = new Map();
const invalidSubscriptions = new Map();
const remoteInvalidSubscriptions = new Map();
const subscriptionsMap = new Map();
subscriptionsMap.set("started", streamStartedSubscriptions);
subscriptionsMap.set("ended", streamEndedSubscriptions);
subscriptionsMap.set("remote-ended", remoteStreamEndedSubscriptions);
subscriptionsMap.set("resized", resizedSubscriptions);
subscriptionsMap.set("invalid", invalidSubscriptions);
subscriptionsMap.set("remote-invalid", remoteInvalidSubscriptions);
function addSubscription(subscriptionMap, uid, callback) {
    try {
        uid = resolveUid(uid);
        let subscriptions = subscriptionMap.get(uid);
        if (!subscriptions) {
            subscriptions = new Set();
            subscriptionMap.set(uid, subscriptions);
        }
        subscriptions.add(callback);
        return true;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}
function removeSubscription(subscriptionMap, uid, callback) {
    uid = resolveUid(uid);
    const subscriptions = subscriptionMap.get(uid);
    if (!subscriptions)
        return;
    subscriptions.delete(callback);
}
function callSubscriptions(subscriptionMap, uid, ...rest) {
    const subscriptions = subscriptionMap.get(uid);
    if (!subscriptions)
        return;
    for (const subscriptionCallback of subscriptions) {
        subscriptionCallback(...rest);
    }
}
connection.subscribeByType(ModelMediaStreamStartedMessage, (msg) => {
    var _a;
    callSubscriptions(streamStartedSubscriptions, msg.uid, msg.uid);
    // TODO: Refactor
    // It's ugly to do this here, but as the scripts do not subscribe to this message,
    // they don't take ownership of the model when the stream is started through the 2D-UI, so we do it here
    if (msg.clientId === ((_a = coreUserService.getLocalUser()) === null || _a === void 0 ? void 0 : _a.clientId)) {
        void networkEntitiesService.takeOwnership(msg.uid);
    }
});
connection.subscribeByType(ModelMediaStreamEndedMessage, (msg, meta) => {
    if (meta.clientId !== undefined) {
        callSubscriptions(remoteStreamEndedSubscriptions, msg.uid, msg.uid, meta.timeStamp);
        return;
    }
    callSubscriptions(streamEndedSubscriptions, msg.uid, msg.uid, meta.timeStamp);
});
connection.subscribeByType(ModelMediaVideoResizedMessage, (msg) => {
    callSubscriptions(resizedSubscriptions, msg.uid, msg.uid, msg.width, msg.height);
});
connection.subscribeByType(ModelMediaVideoInvalidMessage, (msg, meta) => {
    if (meta.clientId !== undefined) {
        callSubscriptions(remoteInvalidSubscriptions, msg.uid, msg.uid, msg.errorCode, meta.timeStamp);
        return;
    }
    callSubscriptions(invalidSubscriptions, msg.uid, msg.uid, msg.errorCode, meta.timeStamp);
});
connection.subscribeByType(RemoveSubModelMessage, (msg) => {
    for (const subscriptions of subscriptionsMap.values()) {
        subscriptions.delete(msg.uid);
    }
});
connection.subscribeByType(RoomChangedMessage, () => {
    for (const subscriptions of subscriptionsMap.values()) {
        subscriptions.clear();
    }
});
export class ScriptMediaManager {
    static setFullScreen(uid) {
        try {
            uid = resolveUid(uid);
            connection.send(new RequestFullscreenMessage(uid));
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
    static startScreenSharing(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            // We don't allow screen sharing in XR
            const isXrPresentingAnswer = yield connection.askByMessageType(new IsXrPresentingRequestMessage(), IsXrPresentingAnswerMessage);
            if (isXrPresentingAnswer !== undefined && isXrPresentingAnswer.xrPresenting)
                return false;
            try {
                uid = resolveUid(uid);
                connection.send(new RequestStartScreenStreamMessage(uid));
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static stopScreenSharing(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                uid = resolveUid(uid);
                connection.send(new RequestStopScreenStreamMessage(uid));
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static startPlayer3dViewSharing(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                uid = resolveUid(uid);
                connection.send(new RequestStartPlayer3dViewSharingMessage(uid));
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static stopPlayer3dViewSharing(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                uid = resolveUid(uid);
                connection.send(new RequestStopPlayer3dViewSharingMessage(uid));
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static subscribeLocalStreamStarted(uid, callback) {
        return addSubscription(streamStartedSubscriptions, uid, callback);
    }
    static unsubscribeLocalStreamStated(uid, callback) {
        removeSubscription(streamStartedSubscriptions, uid, callback);
    }
    static subscribeLocalStreamEnded(uid, callback) {
        return addSubscription(streamEndedSubscriptions, uid, callback);
    }
    static unsubscribeLocalStreamEnded(uid, callback) {
        removeSubscription(streamEndedSubscriptions, uid, callback);
    }
    static subscribeRemoteStreamEnded(uid, callback) {
        return addSubscription(streamEndedSubscriptions, uid, callback);
    }
    static unsubscribeRemoteStreamEnded(uid, callback) {
        removeSubscription(streamEndedSubscriptions, uid, callback);
    }
    static subscribeLocalVideoResized(uid, callback) {
        return addSubscription(resizedSubscriptions, uid, callback);
    }
    static unsubscribeLocalVideoResized(uid, callback) {
        removeSubscription(resizedSubscriptions, uid, callback);
    }
    static subscribeLocalVideoInvalid(uid, callback) {
        return addSubscription(invalidSubscriptions, uid, callback);
    }
    static unsubscribeLocalVideoInvalid(uid, callback) {
        removeSubscription(invalidSubscriptions, uid, callback);
    }
    static subscribeRemoteVideoInvalid(uid, callback) {
        return addSubscription(remoteInvalidSubscriptions, uid, callback);
    }
    static unsubscribeRemoteVideoInvalid(uid, callback) {
        removeSubscription(remoteInvalidSubscriptions, uid, callback);
    }
    static subscribe(type, uid, callback) {
        const subscriptions = subscriptionsMap.get(type);
        if (!subscriptions)
            return false;
        return addSubscription(subscriptions, uid, callback);
    }
    static unsubscribe(type, uid, callback) {
        const subscriptions = subscriptionsMap.get(type);
        if (!subscriptions)
            return false;
        removeSubscription(subscriptions, uid, callback);
    }
    static shareMediaFile(fileId, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield connection.askByMessageType(new ShareMediaFileMessage(fileId, filename), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static stopShareMediaFile(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield connection.askByMessageType(new StopShareMediaFileMessage(fileId), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static createShareUri(fileId) {
        return `shareId:${fileId}`;
    }
    static downloadMediaFile(fileId, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield connection.askByMessageType(new DownloadMediaFileMessage(fileId, fileName), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
    static copyMediaToClipboard(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield connection.askByMessageType(new CopyMediaFileToClipboardMessage(fileId), AskOkMessage);
                return true;
            }
            catch (error) {
                console.error(error);
                return false;
            }
        });
    }
}
